import { createTheme, ThemeOptions } from '@mui/material/styles';
import { mergeStrict } from 'shared/utils/merge/mergeStrict';
import { common } from '@mui/material/colors';

import { baseThemeOptions } from './base';
import { colors, typography } from './config';

const spacing = createTheme({
  spacing: 8,
}).spacing;

const palette = createTheme({
  palette: {
    error: {
      main: colors.monza,
    },
    primary: {
      main: colors.bneiBrakBay,
    },
    text: {
      primary: colors.mineShaft,
    },
    success: {
      main: colors.greenHaze,
    },
  },
}).palette;

const themeOptions: ThemeOptions = {
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: 'underline',
          textDecorationStyle: 'dashed',
          textUnderlineOffset: '4px',

          '&:hover': {
            textDecorationStyle: 'solid',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          ...typography.h6,
          borderRadius: '6px',
          padding: `${spacing(1.3)} ${spacing(2)}`,
          '&:focus': {
            outline: `${colors.cornflowerBlue} solid 3px`,
          },
          '&:disabled': {
            opacity: 0.3,
            background: colors.eastBay,
          },
        },
        containedPrimary: {
          '&': {
            background: colors.eastBay,
            color: common.white,
          },
          '&:disabled': {
            color: common.white,
          },
          '&:hover': {
            background: colors.darkSlateGray,
          },
        },
        text: {
          '&, &:disabled': {
            color: colors.bneiBrakBay,
          },
          '&:hover': {
            background: colors.snuff,
          },
        },
      },
    },
  },
  palette,
};

export const theme = createTheme(mergeStrict<ThemeOptions>(baseThemeOptions, themeOptions));
